import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/notifications/styles.css";
import "./App.css";

import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/react";
import { RouterProvider } from "react-router-dom";

import { ErrorBoundary } from "@/shared/ui/error-boundary";

import { theme } from "./config/theme";
import { router } from "./router";

// Created outside the component so the cache survives re-renders.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <NuqsAdapter
        defaultOptions={{
          clearOnDefault: false,
        }}
      >
        <MantineProvider theme={theme}>
          <Notifications />
          <ErrorBoundary>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </MantineProvider>
      </NuqsAdapter>
    </QueryClientProvider>
  );
}
